import { all, fork, put } from "redux-saga/effects";
import { replace } from "connected-react-router";
import { setAuthError, setSystemError } from "./userData/actions";

import userDataSaga from "./userData/sagas";
import sessionsSaga from "./sessions/sagas";
import emailFlowSaga from "./emailFlow/sagas";
import mainFlowSaga from "./mainFlow/sagas";
import {
  LOGGED_OUT_LINK,
  HOME_LINK,
  SYSTEM_ERROR_LINK,
} from "../App/Http/Http";

export function* generalErrorHandler(errorNumber: number) {
  switch (errorNumber) {
    case 401:
      yield put(setAuthError());
      yield put(replace(LOGGED_OUT_LINK));
      break;
    case 400:
      yield put(replace(HOME_LINK));
      break;
    case 500:
    case 502:
    case 503:
    case 504:
      yield put(setSystemError());
      yield put(replace(SYSTEM_ERROR_LINK));
      break;
    default:
      break;
  }
}

export default function* rootSaga() {
  yield all([
    fork(userDataSaga),
    fork(sessionsSaga),
    fork(emailFlowSaga),
    fork(mainFlowSaga),
  ]);
}
